import React, {useState} from 'react';
import Icon from '../Icons/Icon';
import { useToasts } from '../Toasts';
import { classNames } from '../../Services/helpers';

const CopyableValue = ({title, value, copiedTitle, className, fontMono, trackingWide, flush}) => {
    const [copied, setCopied] = useState(false);
    const {showSuccess} = useToasts();

    const copy = () => {
        navigator.clipboard.writeText(value);
        setCopied(true);
        showSuccess(copiedTitle ? copiedTitle : (title ? `${title} copied to clipboard` : 'Copied to clipboard'));
        setTimeout(() => setCopied(false), 2000);
    }

    return <div className={className ?? null}>
        {title && <div className="font-bold mb-2">{title}</div>}
        <div className={classNames(
            'flex space-between',
            flush !== true && 'p-2 rounded-lg border text-sm transition-colors',
            flush !== true && (copied ? 'bg-blue-100 text-blue-900' : 'bg-slate-100 text-slate-900')
        )} onClick={copy}>
            <span className={classNames(
                'block break-all grow',
                fontMono && 'font-mono',
                trackingWide && 'tracking-widest',
            )}>
                {value}
            </span>
            <Icon icon={copied ? 'Check' : 'Copy'} size="1x" className="ml-2 cursor-pointer shrink-0" />
        </div>
    </div>
}

export default CopyableValue;
